import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';

import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import {default as Reactsel} from 'react-select';

class AdminAddCourseEntityHome extends Component {

  constructor(props){
    super(props);
    this.state = {

    }
  }

  render() {
    return(
      <Grid>
        <GridCell span="12">
          <Link to="/portal/app/admin/course/entity">Create a Course Entity</Link>
        </GridCell>
        <GridCell span="12">
          <Link to="/portal/app/admin/course/entity/list">View the Course Entities</Link>
        </GridCell>
        <GridCell span="12">
          <Link to="/portal/app/admin/purchase/view">View Purchase Orders</Link>
        </GridCell>
      </Grid>
    );
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAddCourseEntityHome);


// WEBPACK FOOTER //
// ./src/views/admin/AdminAddCourseEntityHome.jsx